module.exports = __webpack_public_path__ + "static/thumbnail-store-358b71c4574e8495402f1ffbc8ce0cbf.jpg";